import styled from 'styled-components';

export const SnowSearchTopView = styled.div`
  font-size: 16px;
  width: 600px;
  z-index: 1065;
`;

export const SnowSearchTopMobileView = styled.div`
  font-size: 14px;
  width: 100%;
  z-index: 1065;
  padding: 0 1em;
  [class^="DropDownView"] {
    width: calc(100vw - 2em);
  }
`;

export const JpSnowSearchTopView = styled.div`
  font-size: 16px;
  width: 630px;
  z-index: 1065;
  display: flex;
  [class^="FieldKeywordView"] {
    width: 100%;
    margin-right: 8px;
    .inner {
      input {
        border-radius: 4px;
        box-shadow: 0 0.25em 0.625em rgba(53,118,172,0.4);
      }
    }
  }
`;

export const JpSnowSearchTopMobileView = styled.div`
  font-size: 14px;
  width: 100%;
  z-index: 1065;
  [class^="FieldKeywordView"] {
    .inner {
      input {
        border-radius: 4px;
        box-shadow: 0 0.25em 0.625em rgba(53,118,172,0.4);
      }
    }
  }
  button {
    width: 100%;
  }
  [class^="DropDownView"] {
    width: calc(100vw - 2em);
  }
`;

export const SnowSearchHeaderView = styled.div`
  font-size: 14px;
  z-index: 1065;
  display: flex;
  justify-content: stretch;
  > * {
    margin-right: 0.5em;
    &:last-of-type {
      margin-right: 0;
    }
  }
  [class^="FieldView"] {
    flex: 1;
    .inner {
      input {
        height: 3.5em;
      }
    }
  }
  [class^="FieldKeywordView"] {
    flex: 1;
  }
  [class^="RoomsView"] {
    padding: 1em 0.5em;
  }
`;

export const SnowSearchHeaderMobileView = styled.div`
  font-size: 14px;
  z-index: 1065;
  display: flex;
  justify-content: stretch;
  > * {
    margin-right: 0.5em;
    &:last-of-type {
      margin-right: 0;
    }
  }
  [class^="FieldView"] {
    flex: 1;
  }
  [class^="FieldKeywordView"] {
    flex: 1;
  }
  [class^="RoomsView"] {
    padding: 1em 0.5em;
  }
`;
